<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">首页</BreadcrumbItem>
          <BreadcrumbItem>图集管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">图集管理</div>
      </div>
      <div v-if="String(showTabs) === '1'" class="header-tool-box">
        <div class="htb-item" @click="add('photoTop')">
          <span class="htb-add">+</span>
          <span>添加</span>
        </div>
      </div>
      <div v-if="String(showTabs) === '2'" class="header-tool-box">
        <div class="htb-item" @click="add('photoCompany')">
          <span class="htb-add">+</span>
          <span>添加</span>
        </div>
      </div>
      <div v-if="String(showTabs) === '3'" class="header-tool-box">
        <div class="htb-item" @click="add('photoGroup')">
          <span class="htb-add">+</span>
          <span>添加</span>
        </div>
      </div>
    </div>

    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="首页宣传图" name="1">
          <photoTop ref="photoTop" v-if="String(showTabs) === '1'" @showNum="setNum" />
        </TabPane>
        <TabPane label="企业风采" name="2">
          <photoCompany ref="photoCompany" v-if="String(showTabs) === '2'" @showNum="setNum" />
        </TabPane>
        <TabPane label="印象图集" name="3">
          <photoGroup ref="photoGroup" v-if="String(showTabs) === '3'" @showNum="setNum" />
        </TabPane>
      </Tabs>
    </div>

    <Contact />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Contact from "@components/Contact/Contact";
import photoTop from "./components/photo-top";
import photoCompany from "./components/photo-company";
import photoGroup from "./components/photo-group";
export default {
  name: "exhibition-photo",
  data() {
    return {
      showTabs: "1",
      addPhoto: false,
      materialNum: 0,
      switchName: "1"
    };
  },
  components: {
    Contact,
    photoTop,
    photoCompany,
    photoGroup
  },
  computed: {
    ...mapGetters({
      getMaterial: "materialModule/getMaterial",
      getVideoMaterial: "materialModule/getVideoMaterial"
    }),
    query() {
      return this.$route.query;
    }
  },
  created() {
    this.changeTab();
  },
  methods: {
    changeTab() {
      this.showTabs = "1";
      if (this.query && this.query.type && this.query.type === "company") {
        this.showTabs = "2";
      }
      if (this.query && this.query.type && this.query.type === "group") {
        this.showTabs = "3";
      }
    },
    switchBrand(name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=photo`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=company`);
      } else if (name === "3") {
        this.$router.push(`${this.$route.path}?type=group`);
      }
    },
    add(name) {
      this.$refs[name].showAdd();
    },
    setNum(num) {
      this.materialNum = num;
    }
  }
};
</script> 
<style lang="scss" scoped>
.header-tool {
  display: flex;
  justify-content: space-between;
  padding-right: 25px;
}
</style>